/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* This is recent transactions page having transactions from operative and credit card accounts */

/* 
`<dashboard-user-actions>` shows quick actions for user.

@demo bower_components/speedboat_ui/elements/demo/dashboard-user-actions-demo.html
*/
/*global setBusinessDateString:true*/
import '../behaviors/currency-formator-behaviour.js';
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
import '../behaviors/keyboard-accessibility.js';
import '../../../behaviors/app-menu-access-behaviour.js';
import './app-my-action.js';
import './supporting-msg.js';
const template = html`<style include="app-styles">
            .min-height{
                min-height:100px;
            }
            .dashboard-actions-card[tablet], .dashboard-actions-card[desktop]{
                padding:0px 0px 0px 8px !important;
                border-radius: 0px !important;
                box-shadow: 0px 0px 0px 0px !important;
            }
            :dir(rtl) .dashboard-actions-card[tablet], .dashboard-actions-card[desktop]{
                padding:0px 4px 0px 4px !important;
                border-radius: 0px !important;
                box-shadow: 0px 0px 0px 0px !important;
            }
            :dir(ltr) .bottom-border{
                margin-left:8px;
                margin-right:-8px;
            }
            :dir(rtl) .bottom-border{
                margin-right:8px;
                margin-left:-8px;
            }
            .margin-top-zero[phone]{
                margin-top: 0px !important;
            } 
            @media (max-width:479px){
                .slider__slides ::slotted(paper-slide) {
                    height:unset !important;
                }
                
                .disp-only-in-desktop {
                    display:none;
                }
                .my-actions-text {
                    position: relative;
                    top: 35px;
                    font-size: var(--a-font-size-l);
                    padding: 0px 10px 0px 11px;
                    font-family: var(--medium-font) !important;
                    color: var(--primary-dark-color);
                    line-height:18px;
                }                
                .my-actions-paper-slide {
                    position:relative;
                    top:41px;
                    width:80%
                }
                .my-actions-oe-msg {
                    position: relative;
                    top: 6px;
                }
                
                paper-ripple {
                 		color: var(--field-unchecked-color);
                }
            }
            @media (min-width:768px){
				.display-mobile {
					display:none;
				}
            }

            

            app-swiper[phone] {
                --swiper-slide-style: {
                    width: 90%;
                }
            }
           
            .card-layout {
                width: 290px;
                height: 100px;
            }          

            .my-actions-swiper {
                --swiper-container: {
                    height: 80px !important;
                    padding: 0 16px;
                    width: calc(100% - 32px);
                }
            }
            
        </style>
        <oe-ajax id="getAppStatuses" content-type="application/json" url="/api/codereferences?filter[where][codeType]=APST"
        handle-as="json" method="get" auto on-response="_getDIBAppStatuses" on-error="_fetchDIBError"></oe-ajax>
        <template is="dom-if" if="{{userActionsAvailable}}">

            <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>

            <div class="mdl-grid padding-b-zero display-desktop" >
                <div class="mdl-cell mdl-cell--6-col primary-dark-text-m font-medium outlineOffset" role="heading" level="2" tabindex="0">
                    <oe-i18n-msg msgid="h_MyActions"></oe-i18n-msg><template is="dom-if" if="{{currentFinalList.length}}"><span>({{currentFinalList.length}})</span></template>
                </div>
            </div>

            <template is="dom-if" if="{{userActionsLoader}}">
                <div class="min-height horizontal center-center layout">
                    <paper-spinner id="dashboard_useractions_spinner" active></paper-spinner>
                </div>
            </template>

            <!-- For desktop screen -->
            <template is="dom-if" if="{{!userActionsLoader}}">  
                <template is="dom-if" if="{{!phone}}">
                <template is="dom-if" if="{{showNoDetailsFlag}}" >
    
    <div class="min-height margin horizontal center-center layout">
    <supporting-msg  description="" icon-name="no_txn" background="light-background" title-msg="m_accountsNotLinked"></supporting-msg>
             
  </div>
      </template>
      <template is="dom-if" if="{{!showNoDetailsFlag}}" >
                    <div class="mdl-grid padding-lr-zero padding-t-zero"> 
                        <template is="dom-if" if="{{_checkFinalListLength(currentFinalList)}}">
                            <app-swiper class="my-actions-swiper full-width" navigation-buttons="{{navigationButtons}}" centered-slides={{centeredSlides}} space-between=16 initial-slide="0" slides-per-view=3 slider-effect="slide" tablet$="{{tablet}}" desktop$="{{desktop}}" >         
                                
                                    <template is="dom-repeat" items="{{currentFinalList}}" as="item" restamp="true">
                                        <template is="dom-if" if="{{_showAllActions(index,showAllActions,phone)}}" restamp="true">
                                    <div>
                                        <app-my-actions class="full-width" final-list={{item}} action-index="{{index}}"></app-my-actions>
                                    </div>
                                </template>         
                            </template>
                        </app-swiper>
                        </template>
                    </div>
                    </template>
                </template>

                <!-- For Mobile screen -->
                <template is="dom-if" if="{{phone}}"> 
                    <div class="mdl-grid padding-lr-zero padding-t-zero"> 
                        <template is="dom-if" if="{{_checkFinalListLength(currentFinalList)}}">
                            <app-swiper class="my-actions-swiper full-width" navigation-buttons="{{navigationButtonsMobile}}" centered-slides-mobile="{{centeredSlidesMobile}}" space-between-mobile=16 swiper-pagination={{showSwiperPagination}}
                                        slider-effect="slide" slides-per-view=2 phone$="{{phone}}">
                                    <template is="dom-repeat" items="{{currentFinalList}}" as="item" restamp="true">
                                        <template is="dom-if" if="{{_showAllActions(index,showAllActions,phone)}}" restamp="true">
                                            <div>
                                                <app-my-actions class="full-width" final-list={{item}}></app-my-actions>
                                            </div>
                                        </template>         
                                    </template>
                            </app-swiper>
                        </template>
                    </div>
                </template>
            </template>              
        </template>`

Polymer({
    is: 'dashboard-user-actions',
    _template: template,
    behaviors: [sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appMenuBehaviour, accessibilityBehaviours.commonFunctions, sbBehaviours.retailDashboardBehavior],
    properties: {
        centeredSlidesMobile: {
            type: Boolean,
            value: false,
        },

        bills: {
            type: Array,
            notify: true,
            observer: '_createBillPayList'
        },
        billers: {
            type: Array,
            notify: true,
            observer: '_createBillPayList'
    },
    noDetailsFlag: {
      type: Boolean,
      notify: true,
      observer: "_showMoreFlag"
        },
        cards: {
            type: Array,
            notify: true,
            observer: "_getCreditCardsForBillPayment"
        },
        centeredSlides: {
            type: Boolean,
            value: false,
            notify: true
        },
        billPay: {
            type: Array,
            notify: true,
            observer: "_createFinalList"
        },
        cardPay: {
            type: Array,
            notify: true,
            observer: "_createFinalList"
        },
        showSwiperPagination: {
            type: Boolean,
            value: false,
            notify: true
        },
        loanPay: {
            type: Array,
            notify: true,
            observer: "_createFinalList"
        },
        loans: {
            type: Array,
            notify: true,
            observer: "_getLoanOverdueAccounts"
        },
        /*payment approval*/
        paymentApproval: {
            type: Array,
            notify: true,
            observer: "_createFinalList"
        },
        numberOfTransactions: {
            type: Number,
            value: 10,
            notify: true
        },
        finallist: {
            type: Array,
            notify: true
        },
        currentFinalList: {
            type: Array,
            notify: true,
            value:[]
        },
        userActionsLoader: {
            type: Boolean,
            value: true,
            notify: true
        },
        userActionsAvailable: {
            type: Boolean,
            value: true,
            notify: true
        },
        numberOfActionsHidden: {
            type: String,
            notify: true
        },
        showAllActions: {
            type: Boolean,
            value: true,
            notify: true
        },
        dueBillsStatus: {
            type: Array,
            value: ['WTA', 'PEN', 'OVD']
        },
        loansWithAllAccounts: {
            type: Array,
            notify: true
        },
        navigationButtons: {
            type: Boolean,
            value: true,
            notify: true
        },
        navigationButtonsMobile: {
            type: Boolean,
            value: false,
            notify: true
        },
		applicationList: {
			type: Array,
			notify: true,
			observer: '_createFinalList'
		}
    },
    returnMenuId: function (item) {
        if (item.accountType) {
            if (item.accountType.cmCode === "LAA") {
                return 'ORLNS'
            } else if (item.accountType.cmCode === 'CCD') {
                return 'ORCRD'
            }
        } else if (item.billerBasicDetails) {
            return 'ORBIL'
        }
    },

    _showAllActions: function (index, showAllActions, phone) {
        if (!this.showAllActions && phone) {
            if (index > 1)
                return false;
            else
                return true;
        } else {
            return true;
        }
    },

    _checkLastIndex: function (index, list) {
        if (index === list.length - 1)
            return true;
        return false;
    },

    _changeShowAllActions: function () {
        this.showAllActions = !this.showAllActions;
    },
  _showMoreFlag: function () {

    this.showNoDetailsFlag = this.noDetailsFlag;
  },
    _checkForOverdue: function (temp) {
        var inputDate = "";
        if (temp.paymentDueDate) {
            inputDate = temp.paymentDueDate;
        } else if (temp.billBasicDetails) {
            inputDate = temp.billBasicDetails.dueDate;
        } else if (temp.nextInstallmentDueDate) {
            inputDate = temp.nextInstallmentDueDate;
        } else if (temp.date) {
            inputDate = temp.date;
        } else if(temp.applicationCreationDate){
            inputDate = temp.applicationCreationDate;
        }
        if (inputDate && (!isNaN(getNewDate(inputDate).getTime()))) {
            //Create displayDays
            var date1 = getNewDate();
            date1.setHours(0);
            date1.setMinutes(0);
            date1.setSeconds(0);
            var date2 = getNewDate(inputDate);
            date2.setHours(0);
            date2.setMinutes(0);
            date2.setSeconds(0);
            var timeDiff = date1.getTime() - date2.getTime();
            var diffDays = Math.round(timeDiff / (1000 * 60 * 60 * 24));

            if (diffDays == 0 && temp.status == "PMA") {
                temp.displayDays = getLabel("l_Duetoday");
                //Create classForDays
                temp.classForDays = "input-validation-message";
                temp.classForValidation = "due-today-card";
            } else if (diffDays > 0 && temp.status == "PMA") {
                temp.displayDays = getLabel("l_duesince") + " " + Math.abs(diffDays) + " " + getLabel("l_days");
                temp.classForDays = "input-validation-message";
                temp.classForValidation = "overdue-card";
            } else if (diffDays === 0) {
                temp.displayDays = getLabel("l_Duetoday");
                //Create classForDays
                temp.classForDays = "input-validation-message";
                temp.classForValidation = "due-today-card";
            } else if (diffDays < 0) {
                temp.displayDays = getLabel('l_duein') + " " + Math.abs(diffDays) + " " + getLabel('l_days');
                temp.classForDays = "input-validation-message";
                temp.classForValidation = "scheduled-card";
            } else {
                //Create classForDays
                temp.displayDays = getLabel("l_duesince") + " " + Math.abs(diffDays) + " " + getLabel("l_days");
                temp.classForDays = "input-validation-message";
                temp.classForValidation = "overdue-card";
            }
            temp.payString = getLabel("h_Pay");

            return temp;
        }

    },
    _checkLength: function (list, phone) {
        if (list.length > 2 && phone) {
            return true;
        }
        return false;
    },
    _createFinalList: function () {
        if (this.paymentApproval != undefined && this.cardPay != undefined && this.loanPay != undefined && this.billPay != undefined && this.applicationList != undefined) {
            this._paymentApprovalDataFormation();
            var cardPay = this.cardPay;
            var loanPay = this.loanPay;
            var billPay = this.billPay;
            var paymentApproval = this.paymentApproval;
            var templist = billPay.concat(cardPay);
            templist.sort(function (a, b) {
                return getNewDate(a.displayDate).getTime() - getNewDate(b.displayDate).getTime();
            });
            var finallist = loanPay.concat(templist);
            // finallist = loanPay.concat(templist);
            finallist = finallist.concat(paymentApproval);
            let applicationList = this.applicationList;
            if (!_.isUndefined(applicationList)) {
                finallist = applicationList.concat(finallist);
            }
            if (finallist.length <= 0)
                this.userActionsAvailable = false;
            this.$$("#dashboard_useractions_spinner").active = false;
            this.userActionsLoader = false;
            this.showNoDetailsFlag = false;

            //finallist = finallist.concat(finallist);
            this.set('finallist', finallist);
            this.viewMessage = this.finallist.length - 3 + " more";
            this.currentFinalList = finallist;
            this.numberOfActionsHidden = (this.finallist.length - 2) + " " + getLabel("l_More");
        }

        // if (this.userActionsLoader == true) {
        //     if (screen.width <= 767) {
        //         setTimeout(() => {
        //             if (this.shadowRoot.querySelector('#my-actions-custom-slider')) {
        //                 this.shadowRoot.querySelector('#my-actions-custom-slider').shadowRoot.querySelector('.slider__dots').setAttribute("style", 'bottom: 95% !important;left: unset !important;right:3px !important;transform: unset !important;-webkit-transform: unset !important;');
        //             }

        //         }, 0);

        //     } else {
        //         //do nothing
        //     }
        // }
    },

    _createBillPayList: function () {
        if (this.billers != undefined && this.bills != undefined) {
            var newVal = this.bills;
            var billPay = [];
            for (var i = 0; i < newVal.length; i++) {
                var temp = Object.assign({}, newVal[i]);

                if (temp.billBasicDetails.status.cmCode && this.dueBillsStatus.indexOf(temp.billBasicDetails.status.cmCode) > -1) {
                    //Create displayName
                    temp.displayName = temp.billerBasicDetails.billerName;
                    //Create displayRemark 
                    temp.displayRemark = "";

                    var nickname = "";
                    var category = "";
                    if (temp.billerDetails != undefined && temp.billerDetails.nickName != undefined)
                        nickname = temp.billerDetails.nickName;
                    if (temp.billerBasicDetails != undefined && temp.billerBasicDetails.category != undefined && temp.billerBasicDetails.category.codeDescription != undefined)
                        category = temp.billerBasicDetails.category.codeDescription;
                    if (nickname != "" && category != "")
                        temp.displayRemark = category + " | " + nickname;
                    else
                        temp.displayRemark = category + nickname;
                    //Create displayAmount
                    temp.displayAmount = currency.symbolize(temp.billBasicDetails.amount.currency + ' ' + temp.billBasicDetails.amount.amount)

                    temp = this._checkForOverdue(temp);
                    temp.displayDate = temp.billBasicDetails.dueDate;

                    temp.displayFabImage = "";
                    //Create details navigation data
                    temp.detailsURL = "/biller-details";
                    for (var j = 0; j < this.billers.length; j++) {
                        if (this.billers[j].billerNickname === temp.billerBasicDetails.nickName) {
                            temp.registrationId = this.billers[j].registrationId;
                            temp.displayFabImage = this.billers[j].imageUrl;
                            break;
                        }
                    }

                    if (temp.displayFabImage == undefined || temp.displayFabImage == "")
                        temp.displayFabName = temp.displayName;

                    temp.detailsNavigationData = {
                        registrationId: temp.registrationId,
                        billId: temp.billBasicDetails.billId,
                        upcomingBillType: "Due"
                    };
                    //Create pay navigation data
                    temp.payURL = "/billPayment-new";
                    temp.payNavigationData = {
                        isRegisteredBiller: true,
                        billId: temp.billBasicDetails.billId,
                        billType: "Due",
                        registrationId: temp.registrationId
                    };

                    billPay.push(temp);
                }
            }
            this.billPay = billPay;
        }
    },

    _getLoanOverdueAccounts: function (newVal) {
        if (newVal != undefined) {
            var loanOverdueAccntArray = [];
            for (var i = 0; i < newVal.length; i++) {
                for (var j = 0; j < newVal[i].balances.length; j++) {
                    if (newVal[i].balances[j].type == "overdueAmount" && newVal[i].balances[j].amountDetails.amount !== undefined && newVal[i].balances[j].amountDetails.amount > 0) {
                        var temp = Object.assign({}, newVal[i]);

                        //Create displayName
                        temp.displayName = temp.accountName + " " + maskAccount.accountFormat(temp.accountId, temp.branchCode); //branch id added for feature 301793
                        //Create displayRemark && displayFabImage && displayFabName
                        temp.displayRemark = getLabel("l_LoanPayment");
                        temp.displayFabName = temp.displayName;
                        //Create displayAmount
                        temp.displayAmount = currency.symbolize(newVal[i].balances[j].amountDetails.currency + ' ' + newVal[i].balances[j].amountDetails.amount);
                        //Create displayDays
                        // temp.displayDays = getLabel("l_Overdue");
                        temp = this._checkForOverdue(temp);
                        temp.displayDate = temp.paymentDueDate;
                        //Create classForDays
                        temp.classForDays = "input-validation-message";
                        temp.classForValidation = "overdue-card"
                        temp.payString = getLabel("h_Pay");
                        //Create details navigation data
                        temp.detailsURL = "/loanAcctLanding";
                        temp.detailsNavigationData = {
                            selectedLoanAccount: newVal[i],
                            loanAccountList: this.loansWithAllAccounts,
                            isLoanNavigation: true,
                            selectedloanpage: 0
                        };
                        //Create pay navigation data
                        temp.payURL = "";
                        temp.payNavigationData = {};

                        loanOverdueAccntArray.push(temp);
                        break;
                    }
                }
            }
            this.loanPay = loanOverdueAccntArray;
        }
    },

    _getCreditCardsForBillPayment: function (newVal) {
        if (newVal != undefined) {
            var creditCardBillstoPay = [];
            for (var i = 0; i < newVal.length; i++) {
                for (var j = 0; j < newVal[i].balances.length; j++) {
                    if (newVal[i].balances[j].type == "totalAmountDue" && newVal[i].paymentDueDate && newVal[i].balances[j].amountDetails.amount !== undefined) {
                        var temp = Object.assign({}, newVal[i]);

                        //Create displayName
                        if (temp.cardType == undefined)
                            temp.cardType = "";
                        temp.displayName = temp.cardType + " " + maskAccount.accountFormat(temp.accountId, temp.branchCode); //branch id added for feature 301793
                        //Create displayRemark && displayFabImage && displayFabName
                        temp.displayRemark = getLabel("l_CardPayment");
                        temp.displayFabName = temp.cardType ? temp.displayName : temp.branchCode;
                        //Create displayAmount
                        temp.displayAmount = currency.symbolize(newVal[i].balances[j].amountDetails.currency + ' ' + newVal[i].balances[j].amountDetails.amount)
                        //Create displayDays

                        temp = this._checkForOverdue(temp);
                        temp.displayDate = temp.paymentDueDate;
                        //Create details navigation data
                        temp.detailsURL = "/credit-card-detail";
                        temp.detailsNavigationData = {
                            creditCardNumber: temp.accountId
                        };
                        //Create pay navigation data
                        temp.payURL = "/credit-card-pay";
                        temp.payNavigationData = {
                            creditCardDetail: newVal[i],
                            isIDCallRequired: true,
                            idCallURL: "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/creditcards/" + newVal[i].accountId,
                            responseKey: "creditCardDetail"
                        };
                        creditCardBillstoPay.push(temp);
                        break;
                    }
                }
            }
            this.cardPay = creditCardBillstoPay;
        }

    },

    /**
     * event _paymentApprovalDataFormation for forming the final list body based on the payment approval data
     */
    _paymentApprovalDataFormation: function () {

        for (var i = 0; i < this.paymentApproval.length; i++) {
            var obj = this.paymentApproval[i];

            obj['displayAmount'] = currency.symbolize(obj['transactionCurrency']['cmCode'] + ' ' + obj['totalTransactionAmount']);
            // obj['displayDays'] = OEUtils.DateUtils.format(setBusinessToDateString(obj['transactionDate']), clientStorage.get(storageType.session, "dateFormat"));
            obj['displayDays'] = this._convertDate(obj['transactionDate']);
            if (obj['payeeDetails'].hasOwnProperty("accounts")) {
                if (obj['payeeDetails']['accounts'].hasOwnProperty("accountNickname")) {
                    obj['displayName'] = obj['payeeDetails']['accounts']['accountNickname'];
                }
            } else if (obj['payeeDetails'].hasOwnProperty("paymentBillers")) {
                if (obj['payeeDetails']['paymentBillers'].hasOwnProperty("billerNickname")) {
                    obj['displayName'] = obj['payeeDetails']['paymentBillers']['billerNickname'];
                }
            } else if (obj['payeeDetails'].hasOwnProperty("billPresentmentDetails")) {
                if (obj['payeeDetails']['billPresentmentDetails'].hasOwnProperty("billerNickname")) {
                    obj['displayName'] = obj['payeeDetails']['billPresentmentDetails']['billerNickname'];
                }
            } else if (obj['payeeDetails'].hasOwnProperty("personalPayees")) {
                if (obj['payeeDetails']['personalPayees'].hasOwnProperty("payeeNickname")) {
                    obj['displayName'] = obj['payeeDetails']['personalPayees']['payeeNickname'];
                }
            } else if (obj['payeeDetails'].hasOwnProperty("adhocPayeeDetails")) {
                if (obj['payeeDetails']['adhocPayeeDetails'].hasOwnProperty("payeeNickName")) {
                    obj['displayName'] = obj['payeeDetails']['adhocPayeeDetails']['payeeNickName'];
                }
            } else if (obj['payeeDetails'].hasOwnProperty("adhocBillerDetails")) {
                if (obj['payeeDetails']['adhocBillerDetails'].hasOwnProperty("billerNickname")) {
                    obj['displayName'] = obj['payeeDetails']['adhocBillerDetails']['billerNickname'];
                }
            }

            obj['displayRemark'] = obj['payeeDetails']['counterpartyAccount'];
            obj['displayFabImage'] = "";
            obj['displayFabName'] = obj['displayName'];
            obj.detailsURL = "/joint-pymt-approval";

            var objDetails = {};
            objDetails.referenceId = obj.requestReferenceId;
            objDetails.displayName = obj['displayName'];
            objDetails.displayRemark = obj['displayRemark'];
            objDetails.currency = obj['transactionCurrency'];
            objDetails.amount = obj['totalTransactionAmount'];
            objDetails.displayDays = obj['displayDays'];
            objDetails.status = obj['transactionStatus']['cmCode'];
            objDetails.date = obj["transactionDate"];

            delete obj['totalTransactionAmount'];
            delete obj['transactionDate'];
            delete obj['toAccountNickname'];
            delete obj['counterpartyAccount'];

            obj.detailsNavigationData = {
                selectedJointIndex: 0,
                objDetails: objDetails
            };
            obj.status = objDetails.status;
            obj.date = objDetails.date;
            obj = this._checkForOverdue(obj);
            obj.payURL = "/joint-pymt-approval";
            obj.payString = getLabel("l_approveReject");
            obj.payNavigationData = {
                selectedJointIndex: 0,
                objDetails: objDetails
            };

            this.paymentApproval[i] = obj;
        }
    },

    /**
     * event _convertDate for convert the payment date from api
     */
    _convertDate: function (paymentDate) {
        return moment(paymentDate).format(clientStorage.get(storageType.session, "dateFormat"));
    },

    _isPhone: function () {
        if (this.phone) {
            this.navigationButtons = false;
        }
    },
    //added as part of defect 399972
    _getProductApplications: function () {
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/retailapplications';
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
            if (!_.isNil(event.detail.response) && !_.isEmpty(event.detail.response)) {
                var response = event.detail.response;
                if (_.isArray(event.detail.response)) {
                    response = event.detail.response[0];
                }
                var applicationList = response.applicationDetails.userApplications;
                // var applicationList = [{"applicationStatus":"AS","applicationReferenceNumber":"DO1587283143295","applicationCreationDate":"2020-04-30T00:00:00.000","loanAmount":10000000,"products":[{"productName":"Home Loan","productSubcategory":"PER","opportunityProductsID":"2046","productCode":"APE11","productId":"PROD8725","productMappingId":"PROD8725","currency":"AUD","details":{"interestRate":"-2.147483648E9","purpose":"","termInMonths":"24"},"opportunitiesID":"401741","productCategory":"1"},{"productName":"Personal Loan","productSubcategory":"PER","opportunityProductsID":"2046","productCode":"APE11","productId":"PROD8725","productMappingId":"PROD8725","currency":"AUD","details":{"interestRate":"-2.147483648E9","purpose":"","termInMonths":"24"},"opportunitiesID":"401741","productCategory":"1"}],"loanCurrencySymbol":"A$"},
                // {"applicationStatus":"AS","applicationReferenceNumber":"DO1587283143296","applicationCreationDate":"2022-01-13T00:00:00.000","loanAmount":10000000,"products":[{"productName":"Personal Loan","productSubcategory":"PER","opportunityProductsID":"2046","productCode":"APE11","productId":"PROD8725","productMappingId":"PROD8725","currency":"AUD","details":{"interestRate":"-2.147483648E9","purpose":"","termInMonths":"24"},"opportunitiesID":"401741","productCategory":"1"}],"loanCurrencySymbol":"A$"},
                // {"applicationStatus":"AE","applicationReferenceNumber":"DO1587283143297","applicationCreationDate":"2021-01-14T00:00:00.000","loanAmount":10000000,"products":[{"productName":"Gold Loan","productSubcategory":"PER","opportunityProductsID":"2046","productCode":"APE11","productId":"PROD8725","productMappingId":"PROD8725","currency":"AUD","details":{"interestRate":"-2.147483648E9","purpose":"","termInMonths":"24"},"opportunitiesID":"401741","productCategory":"1"}],"loanCurrencySymbol":"A$"}];
                for (var i = 0; i < applicationList.length; i++) {
                    applicationList[i].productApplication = true;
                    applicationList[i].sortDate = new Date(applicationList[i].applicationCreationDate);
                    applicationList[i].navigateURL = "/directbanking";
                    applicationList[i].displayDays = "DIB";
                    applicationList[i].displayName = applicationList[i].applicationReferenceNumber;
                    let productNames = applicationList[i].products.reduce(function (previousValue, currentValue) {
                        return previousValue +(previousValue ? ',' : '')+ currentValue.productName;
                    },'');
                    let appStatus =  self.applicationStatusData && _.find(self.applicationStatusData, ['cmCode', applicationList[i].applicationStatus]).codeDescription ?
                     _.find(self.applicationStatusData, ['cmCode', applicationList[i].applicationStatus]).codeDescription : '';
                    applicationList[i].displayRemark = (productNames && productNames != 'undefined' ? (productNames + ' - ') : '')  + (appStatus ? appStatus : '');
                    applicationList[i] = self._checkForOverdue(applicationList[i]);
                    if(applicationList[i].applicationStatus == 'AS'){
                        applicationList[i].payString = getLabel("b_resumeC");
                    } else{
                        applicationList[i].payString = getLabel('l_details');
                    }
                    var isExistingCustomer = "Y";
                    var existingCustomerInfo = {};
                    existingCustomerInfo.isExistingCustomer = isExistingCustomer;
                    existingCustomerInfo.applicationInfo = applicationList[i];
                    applicationList[i].navigateData = {
                        existingCustomerInfo: existingCustomerInfo
                    };
                }
                self.applicationList = applicationList;
            } else
                self.applicationList = [];
        });
        ajaxCall.addEventListener("error", function (e) {
            // self.serviceError(e, 'products');
            self.applicationList = [];
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    _getDIBAppStatuses: function(e){
        this.applicationStatusData = _.cloneDeep(e.detail.response);
        this._getProductApplications();
    },
    _fetchDIBError: function(e){
        this.applicationStatusData = [];
        this._getProductApplications();
    },
    _checkFinalListLength:function(currentFinalList){
        return currentFinalList.length > 0;
    }
});
